import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  TextField,
  MenuItem,
  Menu,
  Popover,
  Typography,
  Checkbox,
  Autocomplete,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  useMediaQuery,
  useTheme,
  Collapse,
  Divider,
  IconButton
} from "@mui/material";
import {
  Edit,
  Delete,
  Print,
  Visibility,
  Add,
  Close,
  AttachFile,
  ExpandMore,
  ExpandLess,
} from "@mui/icons-material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Tooltip } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Chip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import InfiniteScroll from "react-infinite-scroll-component";
import config from "../../../config";
import { ToWords } from "to-words";
import dayjs from "dayjs";

import {
  ContraVoucherList,
  UpdateContraVoucher,
  DeleteContraVoucher,
  ApproveContraVoucher,
} from "../../../Services/Services";

const TYPE_MAP = {
  "CASH TO BANK": "Cash to Bank",
  "BANK TO CASH": "Bank to Cash",
  "BANK TO BANK": "Bank to Bank",
};
const toKey = (v = "") => v.replace(/\s+/g, "_").toUpperCase();
const toLabel = (v = "") => TYPE_MAP[toKey(v)] || v; // for table display
const typeOptions = Object.entries(TYPE_MAP).map(([value, label]) => ({
  value,
  label,
}));

const toDateInput = (d) => (d ? String(d).slice(0, 10) : ""); // supports "YYYY-MM-DD" or ISO

function ContraVoucher() {
  const [contraVoucher, setContraVouchers] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const [ContraToApprove, setContraToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);
  const [showRemarkForIndentId, setShowRemarkForIndentId] = useState(null);
  // Edit states (kept as-is; not used after navigation edit)
  const [editOpen, setEditOpen] = useState(false);
  const [editingVoucher, setEditingVoucher] = useState(null);
  // States me add karo
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [expandedContra, setExpandedContra] = useState(null);

  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [customDateRange, setCustomDateRange] = useState({
    from: "",
    to: "",
  });

  const [editForm, setEditForm] = useState({
    voucher_no: "",
    date: "",
    voucher_type: "",
    cash_amount: "",
    narration: "",
  });
  const [actionLoading, setActionLoading] = useState(false);
  const [selectingDate, setSelectingDate] = useState(null);  // ⭐ NEW
  const dateInputRef = React.useRef(null);
  // ⭐ ADD THESE TWO NEW STATES
  const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
  const [tempCustomDateRange, setTempCustomDateRange] = useState({ from: "", to: "" });


  const [filters, setFilters] = useState({
    voucher_no: "",
    account_no: "",
    status: "Pending",
    date_range: "today",
  });
  // Delete states
  const [deleteAnchorEl, setDeleteAnchorEl] = useState(null);
  const [toDelete, setToDelete] = useState(null);
  const userRole = localStorage.getItem("role"); // "admin" ya "staff"
  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      loadVouchers(1, false);
    }, 500);

    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const toWords = new ToWords({ localeCode: "en-IN" });

  useEffect(() => {
    document.body.style.overflow = isMobile ? 'auto' : 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMobile]);


  const loadVouchers = async (
    pageNum = 1,
    reset = false,
    filterValues = filters,
    append = false
  ) => {
    try {
      // ✅ Always send status filter (no "all" option anymore)
      const apiFilters = {
        voucher_no: filterValues.voucher_no,
        account_no: filterValues.account_no,
        status: filterValues.status, // ✅ Direct pass
        date_range: filterValues.date_range,
        from_date: customDateRange.from,
        to_date: customDateRange.to,
      };

      const data = await ContraVoucherList(apiFilters, pageNum);

      if (reset || pageNum === 1) {
        setContraVouchers(Array.isArray(data) ? data : data.results || []);
      } else {
        setContraVouchers((prev) => [
          ...prev,
          ...(Array.isArray(data) ? data : data.results || []),
        ]);
      }

      setHasMore(Array.isArray(data) ? data.next !== null : data.next !== null);
      setPage(pageNum);
    } catch (err) {
      toast.error("Failed to load vouchers");
      setHasMore(false);
    }
  };
  const fetchMoreData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    loadVouchers(nextPage);
  };

  const handleEditClick = async (voucher) => {
    navigate("/dashboard/contra-voucher-create", {
      state: {
        editMode: true,
        voucherData: voucher,
      },
    });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };
  // Edit: navigate to form with state (auto-fill + Update flow)
  const handleOpenEdit = (voucher) => {
    navigate("/dashboard/contra-voucher-create", {
      state: {
        editMode: true,
        voucherData: {
          ...voucher,
          cv_id: voucher.cv_id || null, // ensure cv_id
          voucher_no: voucher.voucher_no || "",
          date: toDateInput(voucher.date),
          voucher_type: voucher.voucher_type || "",
          cash_amount: voucher.cash_amount ?? "",
          from_account: voucher.from_account ?? voucher.from_account_id ?? "",
          to_account: voucher.to_account ?? voucher.to_account_id ?? "",
          narration: voucher.narration || "",
        },
      },
    });
  };

  // Edit dialog handlers (kept as-is; not used now)
  const handleCloseEdit = () => {
    setEditOpen(false);
    setEditingVoucher(null);
  };
  const handleEditChange = (field, value) => {
    setEditForm((prev) => ({ ...prev, [field]: value }));
  };
  const handleUpdate = async () => {
    if (!editingVoucher) return;
    try {
      setActionLoading(true);
      const payload = {
        voucher_no: (editForm.voucher_no || "").trim(),
        date: editForm.date,
        voucher_type: editForm.voucher_type,
        cash_amount: Number(editForm.cash_amount || 0),
        narration: editForm.narration?.trim() || null,
      };
      const id = editingVoucher.cv_id; // cv_id hi use hoga

      const res = await UpdateContraVoucher(id, payload);
      if (res && !res.error) {
        const updated = res?.cv_id ? res : { ...editingVoucher, ...payload };
        setContraVouchers((prev) =>
          prev.map((v) => (v.cv_id === id ? { ...v, ...updated } : v))
        );
        toast.success("Voucher updated");
        handleCloseEdit();
      } else {
        toast.error(res?.message || "Failed to update voucher");
      }
    } catch (e) {
      toast.error("Failed to update voucher");
    } finally {
      setActionLoading(false);
    }
  };

  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (rangeType) {
      case "today":
        return formatDate(now);
      case "yesterday":
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        return formatDate(yesterday);
      case "this_week":
        const weekStart = new Date(now);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
        return `${formatDate(weekStart)} to ${formatDate(now)}`;
      case "previous_week":
        const prevWeekEnd = new Date(now);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        const prevWeekStart = new Date(prevWeekEnd);
        prevWeekStart.setDate(prevWeekStart.getDate() - 6);
        return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
      case "this_month":
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return `${formatDate(monthStart)} to ${formatDate(now)}`;
      case "current_year":
        const yearStart = new Date(now.getFullYear(), 0, 1);
        return `${formatDate(yearStart)} to ${formatDate(now)}`;
      case "financial_year":
        let fyStart;
        if (now.getMonth() >= 3) {
          fyStart = new Date(now.getFullYear(), 3, 1);
        } else {
          fyStart = new Date(now.getFullYear() - 1, 3, 1);
        }
        return `${formatDate(fyStart)} to ${formatDate(now)}`;
      default:
        return "";
    }
  };

  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  const handleApprove = async (voucher) => {
    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    try {
      const updated = await ApproveContraVoucher(
        voucher.cv_id, // <-- important change
        approvedById,
        voucher.status,
        remarkInput
      );

      setContraVouchers((prev) =>
        prev.map((item) => (item.cv_id === updated.cv_id ? updated : item))
      );

      toast.success("Contra Voucher approved successfully!");
    } catch (error) {
      console.error("Approval Error:", error);
      toast.error("Failed to approve Contra Voucher.");
    }
  };
  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  // Delete handlers
  const openDeletePopover = (e, voucher) => {
    setDeleteAnchorEl(e.currentTarget);
    setToDelete(voucher);
  };
  const closeDeletePopover = () => {
    setDeleteAnchorEl(null);
    setToDelete(null);
  };
  const confirmDelete = async () => {
    if (!toDelete) return;
    try {
      setActionLoading(true);
      const id = toDelete.cv_id; // cv_id hi hai
      const res = await DeleteContraVoucher(id);
      if (res && !res.error) {
        setContraVouchers((prev) => prev.filter((v) => v.cv_id !== id));
        toast.success("Voucher deleted");
      } else {
        toast.error(res?.message || "Failed to delete voucher");
      }
    } catch (e) {
      toast.error("Failed to delete voucher");
    } finally {
      setActionLoading(false);
      closeDeletePopover();
    }
  };

  // ⭐ ADD THESE TWO FUNCTIONS AFTER formatDateDisplay

  // ✅ Apply Custom Date Range
  const handleApplyCustomDateRange = () => {
    if (tempCustomDateRange.from && tempCustomDateRange.to) {
      setCustomDateRange({ ...tempCustomDateRange });
      setFilters((prev) => ({ ...prev, date_range: "custom" }));
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    } else {
      toast.warning("Please select both From and To dates");
    }
  };

  // ✅ Cancel Custom Date Range
  const handleCancelCustomDateRange = () => {
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };
  return (
    <>
      <ToastContainer />

      {/* ✅ Responsive Filters */}
      <Box
        display="flex"
        flexWrap={{ xs: "wrap", md: "nowrap" }}
        alignItems="center"
        sx={{
          mt: -4,
          mb: 1,
          width: "100%",
          gap: 2,
        }}
      >
        {/* Status Filter - Radio Buttons */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexShrink: 0,
            width: { xs: "100%", md: "auto" },
            justifyContent: { xs: "space-around", md: "flex-start" },
          }}
        >
          <FormControl component="fieldset">
            <RadioGroup
              row
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
              sx={{
                display: "flex",
                gap: { xs: 1, md: 1 }, // ✅ Mobile mein bhi proper gap
              }}
            >
              <FormControlLabel
                value="Pending"
                control={<Radio size="small" />}
                label="Pending"
                sx={{
                  mr: 0, // ✅ Negative margin remove
                  transform: "scale(0.9)",
                  "& .MuiFormControlLabel-label": {
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                  },
                }}
              />
              <FormControlLabel
                value="Approved"
                control={<Radio size="small" />}
                label="Approved"
                sx={{
                  mr: 0, // ✅ Negative margin remove
                  transform: "scale(0.9)",
                  "& .MuiFormControlLabel-label": {
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                  },
                }}
              />
              <FormControlLabel
                value="Rejected"
                control={<Radio size="small" />}
                label="Rejected"
                sx={{
                  transform: "scale(0.9)",
                  "& .MuiFormControlLabel-label": {
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                  },
                }}
              />
            </RadioGroup>
          </FormControl>
        </Box>

        <Box sx={{
          width: {
            xs: "100%",   // = Grid xs={12}
            sm: "50%",    // = Grid sm={6}
            md: "20%", // = Grid md={2}  (2/12 = 16.66%)
          },
        }}>
          <TextField
            label="Date Range"
            value={
              filters.date_range === "custom" &&
                customDateRange.from &&
                customDateRange.to
                ? `${formatDateDisplay(customDateRange.from)} to ${formatDateDisplay(customDateRange.to)}`
                : filters.date_range === "today"
                  ? "Today"
                  : filters.date_range === "yesterday"
                    ? "Yesterday"
                    : filters.date_range === "this_week"
                      ? "This Week"
                      : filters.date_range === "previous_week"
                        ? "Previous Week"
                        : filters.date_range === "this_month"
                          ? "This Month"
                          : "Select Date Range"
            }
            onClick={(e) => setDateMenuAnchor(e.currentTarget)}
            size="small"
            fullWidth
            InputProps={{
              readOnly: true,
              endAdornment: (
                <IconButton size="small" edge="end">
                  <ArrowDropDownIcon />
                </IconButton>
              ),
            }}
            sx={{
              cursor: "pointer",
              "& .MuiInputBase-input": {
                fontSize: "0.8rem",
                padding: "4px 8px",
              },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.7rem",
              },
            }}
          />
        </Box>



        {/* Search Fields Container */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flex: 1,
            width: "100%",
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          {/* Voucher Number Search */}
          <TextField
            label="Search by Voucher No"
            size="small"
            name="voucher_no"
            value={filters.voucher_no}
            onChange={handleFilterChange}
            sx={{
              flex: { xs: "none", md: 1 },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
                fontSize: { xs: "0.75rem", sm: "0.8rem" },
              },
              "& .MuiInputLabel-root": {
                fontSize: { xs: "0.65rem", sm: "0.7rem" },
              },
            }}
          />

          {/* Account Number Search */}
          <TextField
            label="From/To Account No"
            name="account_no"
            size="small"
            value={filters.account_no}
            onChange={handleFilterChange}
            sx={{
              flex: { xs: "none", md: 1 },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
                fontSize: { xs: "0.75rem", sm: "0.8rem" },
              },
              "& .MuiInputLabel-root": {
                fontSize: { xs: "0.65rem", sm: "0.7rem" },
              },
            }}
          />
        </Box>

        {/* ⭐ REPLACE OLD MENU WITH THIS */}
        <Menu
          anchorEl={dateMenuAnchor}
          open={Boolean(dateMenuAnchor)}
          onClose={() => {
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
            setTempCustomDateRange({ from: "", to: "" });
          }}
          PaperProps={{
            sx: { width: 350, maxHeight: 500 },
          }}
        >
          {/* Quick Ranges */}
          {[
            { key: "today", label: "Today" },
            { key: "yesterday", label: "Yesterday" },
            { key: "this_week", label: "This Week" },
            { key: "previous_week", label: "Previous Week" },
            { key: "this_month", label: "This Month" },
          ].map((item) => (
            <MenuItem
              key={item.key}
              onClick={() => {
                setFilters((prev) => ({ ...prev, date_range: item.key }));
                setCustomDateRange({ from: "", to: "" });
                setDateMenuAnchor(null);
                setShowCustomDateInputs(false);
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography variant="body2">{item.label}</Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: "0.7rem" }}
                >
                  {getDateRangeDisplay(item.key)}
                </Typography>
              </Box>
            </MenuItem>
          ))}

          <Divider />

          {/* ✅ Custom Date Range - Expandable */}
          <MenuItem
            onClick={() => setShowCustomDateInputs((prev) => !prev)}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}
            >
              Custom Date Range
            </Typography>
            {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
            <Box
              sx={{
                px: 2,
                py: 2,
                bgcolor: "#f5f5f5",
                borderTop: "1px solid #e0e0e0",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mb: 1, display: "block" }}
              >
                Select Date Range
              </Typography>

              {/* From and To Date Inputs Side by Side */}
              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.from}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      from: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max: tempCustomDateRange.to || undefined,
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />

                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.to}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      to: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: tempCustomDateRange.from || undefined,
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />
              </Box>

              {/* Selected Range Preview */}
              {tempCustomDateRange.from && tempCustomDateRange.to && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 1.5,
                    p: 1,
                    bgcolor: "#e8f5e9",
                    borderRadius: 1,
                    textAlign: "center",
                    color: "#2e7d32",
                    fontWeight: 500,
                  }}
                >
                  📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
                  {formatDateDisplay(tempCustomDateRange.to)}
                </Typography>
              )}

              {/* Apply and Cancel Buttons */}
              <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCancelCustomDateRange}
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleApplyCustomDateRange}
                  disabled={
                    !tempCustomDateRange.from || !tempCustomDateRange.to
                  }
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Apply
                </Button>
              </Box>
            </Box>
          </Collapse>
        </Menu>
      </Box >


      {/* ✅ Mobile/Desktop Conditional Rendering */}
      < InfiniteScroll
        dataLength={contraVoucher.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={< h4 > Loading...</h4 >}
        endMessage={< p style={{ textAlign: "center" }}> No more vouchers!</p >}
      >
        {
          isMobile ? (
            /* 📱 MOBILE VIEW - Collapsible Cards */
            <Box sx={{ bgcolor: "background.paper" }} >
              {
                contraVoucher.map((voucher, index) => (
                  <Box key={index}>
                    <Box
                      onClick={() =>
                        setExpandedContra(
                          expandedContra === voucher.cv_id ? null : voucher.cv_id
                        )
                      }
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 1.5,
                        cursor: "pointer",
                        bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                        "&:active": { bgcolor: "#e3f2fd" },
                        borderLeft: `4px solid ${voucher.status === "Approved"
                          ? "#4caf50"
                          : voucher.status === "Rejected"
                            ? "#f44336"
                            : "#ff9800"
                          }`,
                      }}
                    >
                      <Box sx={{ flex: 1 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mb: 0.5,
                          }}
                        >
                          <Typography
                            sx={{ fontSize: "0.7rem", color: "#666", minWidth: 25 }}
                          >
                            #{index + 1}
                          </Typography>
                          <Typography
                            sx={{ fontWeight: "bold", fontSize: "0.85rem", flex: 1 }}
                          >
                            {voucher.voucher_no}
                          </Typography>
                        </Box>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            color: "#666",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <span style={{ fontWeight: 500 }}>
                            {toLabel(voucher.voucher_type)}
                          </span>
                          <span style={{ color: "#999" }}>•</span>
                          <span style={{ fontSize: "0.7rem" }}>
                            {new Date(voucher.date).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })}
                          </span>
                        </Typography>
                      </Box>
                      <IconButton size="small" sx={{ ml: 1 }}>
                        {expandedContra === voucher.cv_id ? (
                          <ExpandLess fontSize="small" />
                        ) : (
                          <ExpandMore fontSize="small" />
                        )}
                      </IconButton>
                    </Box>

                    <Collapse
                      in={expandedContra === voucher.cv_id}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Box
                        sx={{
                          px: 1.5,
                          py: 1,
                          bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                          borderLeft: `4px solid ${voucher.status === "Approved"
                            ? "#4caf50"
                            : voucher.status === "Rejected"
                              ? "#f44336"
                              : "#ff9800"
                            }`,
                        }}
                      >
                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: 0.8,
                            mb: 1,
                          }}
                        >
                          <Box sx={{ gridColumn: "1 / -1" }}>
                            <Typography
                              sx={{
                                fontSize: "0.6rem",
                                color: "#999",
                                letterSpacing: "0.5px",
                              }}
                            >
                              VOUCHER TYPE
                            </Typography>
                            <Typography
                              sx={{ fontSize: "0.75rem", fontWeight: 500, color: "#333" }}
                            >
                              {toLabel(voucher.voucher_type)}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              sx={{
                                fontSize: "0.6rem",
                                color: "#999",
                                letterSpacing: "0.5px",
                              }}
                            >
                              AMOUNT
                            </Typography>
                            <Typography
                              sx={{ fontSize: "0.72rem", fontWeight: 600, color: "#1976d2" }}
                            >
                              ₹{" "}
                              {Number(voucher.cash_amount || 0).toLocaleString("en-IN")}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              sx={{
                                fontSize: "0.6rem",
                                color: "#999",
                                letterSpacing: "0.5px",
                                mb: 0.3,
                              }}
                            >
                              STATUS
                            </Typography>
                            <Chip
                              label={
                                voucher.status === "Approved"
                                  ? "Approved"
                                  : voucher.status === "Rejected"
                                    ? "Rejected"
                                    : "Pending"
                              }
                              color={
                                voucher.status === "Approved"
                                  ? "success"
                                  : voucher.status === "Rejected"
                                    ? "error"
                                    : "warning"
                              }
                              variant="outlined"
                              size="small"
                              sx={{ height: 20, fontSize: "0.65rem" }}
                            />
                          </Box>

                          <Box sx={{ gridColumn: "1 / -1" }}>
                            <Typography
                              sx={{
                                fontSize: "0.6rem",
                                color: "#999",
                                letterSpacing: "0.5px",
                              }}
                            >
                              FROM ACCOUNT
                            </Typography>
                            <Typography
                              sx={{ fontSize: "0.72rem", fontWeight: 500, color: "#555" }}
                            >
                              {voucher.from_account_name || "-"}
                            </Typography>
                          </Box>

                          <Box sx={{ gridColumn: "1 / -1" }}>
                            <Typography
                              sx={{
                                fontSize: "0.6rem",
                                color: "#999",
                                letterSpacing: "0.5px",
                              }}
                            >
                              TO ACCOUNT
                            </Typography>
                            <Typography
                              sx={{ fontSize: "0.72rem", fontWeight: 500, color: "#555" }}
                            >
                              {voucher.to_account_name || "-"}
                            </Typography>
                          </Box>

                          {voucher.created_by_name && (
                            <Box>
                              <Typography
                                sx={{
                                  fontSize: "0.6rem",
                                  color: "#999",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                CREATED BY
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "0.72rem",
                                  fontWeight: 500,
                                  color: "#555",
                                }}
                              >
                                {voucher.created_by_name}
                              </Typography>
                            </Box>
                          )}

                          {voucher.approved_name && (
                            <Box>
                              <Typography
                                sx={{
                                  fontSize: "0.6rem",
                                  color: "#999",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                APPROVED BY
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "0.72rem",
                                  fontWeight: 500,
                                  color: "#555",
                                }}
                              >
                                {voucher.approved_name}
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        {voucher.narration && (
                          <Box sx={{ mb: 0.8 }}>
                            <Typography
                              sx={{
                                fontSize: "0.6rem",
                                color: "#999",
                                letterSpacing: "0.5px",
                                mb: 0.3,
                              }}
                            >
                              NARRATION
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "0.7rem",
                                color: "#555",
                                fontStyle: "italic",
                                lineHeight: 1.3,
                              }}
                            >
                              {voucher.narration}
                            </Typography>
                          </Box>
                        )}

                        {voucher.remarks && (
                          <Box sx={{ mb: 0.8 }}>
                            <Typography
                              sx={{
                                fontSize: "0.6rem",
                                color: "#999",
                                letterSpacing: "0.5px",
                                mb: 0.3,
                              }}
                            >
                              REMARKS
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "0.7rem",
                                color: "#555",
                                fontStyle: "italic",
                                lineHeight: 1.3,
                              }}
                            >
                              {voucher.remarks}
                            </Typography>
                          </Box>
                        )}

                        <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          {userRole != "Staff" && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                                bgcolor:
                                  voucher.status === "Approved"
                                    ? "#e8f5e9"
                                    : voucher.status === "Rejected"
                                      ? "#ffebee"
                                      : "#fff3e0",
                                px: 1,
                                py: 0.5,
                                borderRadius: "6px",
                                border: `1px solid ${voucher.status === "Approved"
                                  ? "#4caf50"
                                  : voucher.status === "Rejected"
                                    ? "#f44336"
                                    : "#ff9800"
                                  }`,
                              }}
                            >
                              <Checkbox
                                checked={
                                  voucher.status === "Approved" ||
                                  voucher.status === "Rejected"
                                }
                                onChange={(e) => {
                                  e.stopPropagation();
                                  setApproveAnchorEl(e.currentTarget);
                                  setContraToApprove(voucher);
                                }}
                                sx={{
                                  padding: 0,
                                  transform: "scale(0.75)",
                                  color:
                                    voucher.status === "Approved"
                                      ? "#4caf50"
                                      : voucher.status === "Rejected"
                                        ? "#f44336"
                                        : "#ff9800",
                                  "&.Mui-checked": {
                                    color:
                                      voucher.status === "Approved"
                                        ? "#4caf50"
                                        : "#f44336",
                                  },
                                }}
                              />
                              <Typography
                                sx={{
                                  fontSize: "0.7rem",
                                  fontWeight: 600,
                                  color:
                                    voucher.status === "Approved"
                                      ? "#2e7d32"
                                      : voucher.status === "Rejected"
                                        ? "#c62828"
                                        : "#f57c00",
                                }}
                              >
                                {voucher.status === "Approved"
                                  ? "Approved"
                                  : voucher.status === "Rejected"
                                    ? "Rejected"
                                    : "Approve"}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </Collapse>
                    <Divider />
                  </Box>
                ))
              }
            </Box >
          ) : (
            /* 💻 DESKTOP VIEW - Table */
            <TableContainer
              component={Paper}
              sx={{
                maxHeight: "88vh",
                overflow: "auto",
              }}
            >
              <Table
                stickyHeader
                size="small"
                sx={{
                  minWidth: 1600,
                  "& td, & th": {
                    borderBottom: "1px solid #ccc",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    backgroundColor: "#f5f5f5 !important",
                  },
                }}
              >
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: "#f5f5f5 !important",
                      "& th": {
                        fontWeight: "bold !important",
                        color: "#333",
                        borderBottom: "1px solid #999",
                        whiteSpace: "nowrap",
                        fontSize: "0.75rem"
                      },
                    }}
                  >
                    {userRole != "Staff" && (
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          backgroundColor: "#fafafa !important",
                          zIndex: 3,
                        }}
                      >
                        Approve
                      </TableCell>
                    )}
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: userRole != "Staff" ? 80 : 0,
                        backgroundColor: "#f5f5f5 !important",
                        zIndex: 3,
                      }}
                    >
                      S.No.
                    </TableCell>
                    <TableCell>Voucher No</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Voucher Type</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>From Account</TableCell>
                    <TableCell>To Account</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Narration</TableCell>
                    <TableCell>Created By</TableCell>
                    <TableCell>Approved By</TableCell>
                    <TableCell>Remarks</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {contraVoucher.map((voucher, index) => (
                    <TableRow
                      hover
                      key={`${voucher.cv_id || voucher.voucher_no || index}-${index}`}
                      sx={{
                        backgroundColor: index % 2 === 0 ? "#fafafa !important" : "#ffffff !important",
                        "&:hover": {
                          backgroundColor: "#e3f2fd !important",
                          "& td": { backgroundColor: "#e3f2fd !important" },
                        },
                        "& td": {
                          paddingRight: "13px !important",
                          paddingLeft: "13px !important",
                          padding: "0px",
                          fontSize: { xs: "0.65rem", sm: "0.75rem" },
                          whiteSpace: "nowrap",
                          color: (theme) =>
                            theme.palette.mode === "dark" ? "white" : "inherit",
                          backgroundColor: (theme) =>
                            theme.palette.mode === "dark !important" ? "black !important" : "inherit !important",
                        },
                      }}
                    >
                      {userRole != "Staff" && (
                        <TableCell
                          sx={{
                            position: "sticky",
                            left: 0,
                            backgroundColor: "#fafafa !important",
                            zIndex: 3,
                          }}
                        >
                          <Checkbox
                            checked={
                              voucher.status === "Approved" ||
                              voucher.status === "Rejected"
                            }
                            onChange={(e) => {
                              setApproveAnchorEl(e.currentTarget);
                              setContraToApprove(voucher);
                            }}
                            sx={{
                              padding: 0,
                              paddingLeft: 1,
                              paddingRight: 1,
                              transform: "scale(0.6)",
                              color:
                                voucher.status === "Approved"
                                  ? "green"
                                  : voucher.status === "Rejected"
                                    ? "red"
                                    : "grey",
                              "&.Mui-checked": {
                                color:
                                  voucher.status === "Approved" ? "green" : "red",
                              },
                            }}
                          />
                        </TableCell>
                      )}
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: userRole != "Staff" ? 80 : 0,
                          backgroundColor: "#f5f5f5 !important",
                          zIndex: 3,
                        }}
                      >
                        {index + 1}
                      </TableCell>

                      <TableCell>{voucher.voucher_no}</TableCell>
                      <TableCell align="center">
                        <Chip
                          label={
                            voucher.status === "Approved"
                              ? "Approved"
                              : voucher.status === "Rejected"
                                ? "Rejected"
                                : "Pending"
                          }
                          color={
                            voucher.status === "Approved"
                              ? "success"
                              : voucher.status === "Rejected"
                                ? "error"
                                : "warning"
                          }
                          variant="outlined"
                          size="small"
                          sx={{
                            // fontSize: "0.2rem", // 👈 font chhota hoga
                            height: "10px",
                            transform: "scale(0.8)",
                            "& .MuiChip-label": {
                              padding: "0 6px",
                            },
                          }}
                        />
                      </TableCell>
                      <TableCell>{toLabel(voucher.voucher_type)}</TableCell>
                      <TableCell>{voucher.cash_amount}</TableCell>
                      <TableCell>{voucher.from_account_name}</TableCell>
                      <TableCell>{voucher.to_account_name}</TableCell>
                      <TableCell>
                        {new Date(voucher.date).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })}
                      </TableCell>
                      <TableCell>{voucher.narration}</TableCell>
                      <TableCell>{voucher.created_by_name}</TableCell>
                      <TableCell>{voucher.approved_name}</TableCell>
                      <TableCell>
                        <Tooltip title={voucher.remarks || ""} arrow>
                          <span>{truncateText(voucher.remarks || "", 20)}</span>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
      </InfiniteScroll >

      {/* approve pop */}
      <Popover
        open={Boolean(approveAnchorEl)}
        anchorEl={approveAnchorEl}
        onClose={() => {
          setApproveAnchorEl(null);
          setContraToApprove(null);
          setRemarkInput("");
          setShowRemarkForIndentId(null);
          setActionType(null);
        }}
        anchorReference="anchorPosition"
        anchorPosition={{
          top: window.innerHeight / 2,
          left: window.innerWidth / 2,
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        PaperProps={{
          sx: {
            // Desktop
            width: { md: "auto" },
            maxWidth: { md: 1050 },

            // Mobile centering
            "@media (max-width: 899px)": {
              position: "fixed",
              top: "53%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "calc(100% - 32px)",
              maxWidth: "calc(100% - 32px)",
              maxHeight: "85vh",
              overflowY: "auto",
              margin: 0,
              borderRadius: "12px",
            },
          },
        }}
        sx={{
          "& .MuiPopover-paper": {
            "@media (max-width: 899px)": {
              position: "fixed !important",
              top: "53% !important",
              left: "50% !important",
              transform: "translate(-50%, -50%) !important",
              margin: "0 !important",
            },
          },
        }}
      >
        <Box sx={{ py: { xs: 1.5, md: 1 }, px: { xs: 1.5, md: 2 }, minWidth: { xs: "auto", md: 1050 } }}>

          {/* ================= MOBILE VIEW ================= */}
          <Box sx={{ display: { xs: "block", md: "none" } }}>

            {/* CONTRA VOUCHER Header */}
            <Box
              sx={{
                bgcolor: "#d9d8d8ff",
                p: 1.5,
                textAlign: "center",
                fontWeight: "bold",
                borderRadius: "8px 8px 0 0",
                fontSize: "0.9rem",
              }}
            >
              CONTRA VOUCHER
            </Box>

            {/* Basic Info Card */}
            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderTop: "none",
                borderRadius: "0 0 8px 8px",
                overflow: "hidden",
                mb: 1.5,
                bgcolor: "#fff",
              }}
            >
              {/* Row 1 */}
              <Box sx={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0", bgcolor: "#f8f9fa" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Voucher No.
                  </Typography>
                  <Typography variant="body2" fontWeight={600} color="primary" sx={{ fontSize: "0.8rem" }}>
                    {ContraToApprove?.voucher_no || "-"}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, p: 1.5 }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Status
                  </Typography>
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    sx={{
                      fontSize: "0.8rem",
                      color: ContraToApprove?.status === "Approved" ? "success.main" :
                        ContraToApprove?.status === "Rejected" ? "error.main" : "warning.main"
                    }}
                  >
                    {ContraToApprove?.status || "Pending"}
                  </Typography>
                </Box>
              </Box>

              {/* Row 2 */}
              <Box sx={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Date
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                    {ContraToApprove?.date
                      ? dayjs(ContraToApprove.date).format("DD/MM/YYYY")
                      : "-"}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, p: 1.5, bgcolor: "#f8f9fa" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Amount
                  </Typography>
                  <Typography variant="body2" fontWeight={700} color="success.main" sx={{ fontSize: "0.85rem" }}>
                    ₹{ContraToApprove?.cash_amount || "0.00"}
                  </Typography>
                </Box>
              </Box>

              {/* Row 3 */}
              <Box sx={{ display: "flex" }}>
                <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0", bgcolor: "#f8f9fa" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Transfer Type
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                    {ContraToApprove?.transfer_type || "Bank to bank"}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, p: 1.5 }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Created By
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                    {ContraToApprove?.created_by_name || "-"}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* BANK TO BANK - Mobile */}
            {ContraToApprove?.voucher_type === "BANK TO BANK" && (
              <Box
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  overflow: "hidden",
                  mb: 1.5,
                  bgcolor: "#fff",
                }}
              >
                <Box sx={{ bgcolor: "#e3f2fd", p: 1, textAlign: "center", borderBottom: "1px solid #e0e0e0" }}>
                  <Typography variant="caption" fontWeight={600} color="primary" sx={{ fontSize: "0.75rem" }}>
                    BANK TO BANK
                  </Typography>
                </Box>
                <Box sx={{ display: "flex" }}>
                  <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0" }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      From Bank
                    </Typography>
                    <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem", wordBreak: "break-word" }}>
                      {ContraToApprove?.from_account_name || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1, p: 1.5 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      To Bank
                    </Typography>
                    <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem", wordBreak: "break-word" }}>
                      {ContraToApprove?.to_account_name || "-"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}

            {/* CASH TO BANK - Mobile */}
            {ContraToApprove?.voucher_type === "CASH TO BANK" && (
              <Box
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  overflow: "hidden",
                  mb: 1.5,
                  bgcolor: "#fff",
                }}
              >
                <Box sx={{ bgcolor: "#e8f5e9", p: 1, textAlign: "center", borderBottom: "1px solid #e0e0e0" }}>
                  <Typography variant="caption" fontWeight={600} color="success.main" sx={{ fontSize: "0.75rem" }}>
                    CASH TO BANK
                  </Typography>
                </Box>

                {/* Row 1 */}
                <Box sx={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                  <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0" }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      From Cash
                    </Typography>
                    <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                      Cash Account
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1, p: 1.5 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      To Bank
                    </Typography>
                    <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem", wordBreak: "break-word" }}>
                      {ContraToApprove?.to_account_name || "-"}
                    </Typography>
                  </Box>
                </Box>

                {/* Row 2 */}
                <Box sx={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                  <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0" }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      Cash Amount
                    </Typography>
                    <Typography variant="body2" fontWeight={600} color="success.main" sx={{ fontSize: "0.8rem" }}>
                      ₹{ContraToApprove?.cash_amount || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1, p: 1.5 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      Deposit Date
                    </Typography>
                    <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                      {ContraToApprove?.date || "-"}
                    </Typography>
                  </Box>
                </Box>

                {/* Row 3 */}
                <Box sx={{ p: 1.5, borderBottom: "1px solid #e0e0e0" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Deposited By
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                    {ContraToApprove?.created_by_name || "-"}
                  </Typography>
                </Box>

                {/* Amount in Words */}
                <Box sx={{ p: 1.5, bgcolor: "#f8f9fa" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Amount in Words
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.75rem", fontStyle: "italic" }}>
                    {toWords.convert(ContraToApprove?.cash_amount || 0)}
                  </Typography>
                </Box>
              </Box>
            )}

            {/* BANK TO CASH - Mobile */}
            {ContraToApprove?.voucher_type === "BANK TO CASH" && (
              <Box
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  overflow: "hidden",
                  mb: 1.5,
                  bgcolor: "#fff",
                }}
              >
                <Box sx={{ bgcolor: "#fff3e0", p: 1, textAlign: "center", borderBottom: "1px solid #e0e0e0" }}>
                  <Typography variant="caption" fontWeight={600} color="warning.main" sx={{ fontSize: "0.75rem" }}>
                    BANK TO CASH
                  </Typography>
                </Box>

                {/* Row 1 */}
                <Box sx={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                  <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0" }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      From Bank
                    </Typography>
                    <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem", wordBreak: "break-word" }}>
                      {ContraToApprove?.from_account_name || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1, p: 1.5 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      To Account
                    </Typography>
                    <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                      Cash Account
                    </Typography>
                  </Box>
                </Box>

                {/* Row 2 */}
                <Box sx={{ display: "flex", borderBottom: "1px solid #e0e0e0" }}>
                  <Box sx={{ flex: 1, p: 1.5, borderRight: "1px solid #e0e0e0" }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      Cash Amount
                    </Typography>
                    <Typography variant="body2" fontWeight={600} color="success.main" sx={{ fontSize: "0.8rem" }}>
                      ₹{ContraToApprove?.cash_amount || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1, p: 1.5 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                      Cheque/Ref No.
                    </Typography>
                    <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                      {ContraToApprove?.cheque_no || "-"}
                    </Typography>
                  </Box>
                </Box>

                {/* Row 3 */}
                <Box sx={{ p: 1.5, borderBottom: "1px solid #e0e0e0" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Withdrawn By
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.8rem" }}>
                    {ContraToApprove?.created_by_name || "-"}
                  </Typography>
                </Box>

                {/* Amount in Words */}
                <Box sx={{ p: 1.5, bgcolor: "#f8f9fa" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    Amount in Words
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ fontSize: "0.75rem", fontStyle: "italic" }}>
                    {toWords.convert(ContraToApprove?.cash_amount || 0)}
                  </Typography>
                </Box>
              </Box>
            )}

            {/* Narration Card - Mobile */}
            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                p: 1.5,
                bgcolor: "#f8f9fa",
                mb: 1.5,
              }}
            >
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                Narration
              </Typography>
              <Typography variant="body2" sx={{ fontSize: "0.8rem", wordBreak: "break-word" }}>
                {ContraToApprove?.narration || "-"}
              </Typography>
            </Box>
          </Box>

          {/* ================= DESKTOP VIEW - UNCHANGED ================= */}
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <Table
              size="small"
              sx={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "14px",
                backgroundColor: "#fff",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <TableBody>
                <TableRow sx={{ bgcolor: "#d9d8d8ff" }}>
                  <TableCell colSpan={4} align="center" sx={{ fontWeight: "bold" }}>
                    CONTRA VOUCHER
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><b>Voucher No.</b></TableCell>
                  <TableCell>: {ContraToApprove?.voucher_no || "-"}</TableCell>
                  <TableCell><b>Status</b></TableCell>
                  <TableCell>: {ContraToApprove?.status || "Pending"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><b>Date</b></TableCell>
                  <TableCell>
                    :{" "}
                    {ContraToApprove?.date
                      ? dayjs(ContraToApprove.date).format("DD/MM/YYYY")
                      : "-"}
                  </TableCell>
                  <TableCell><b>Amount</b></TableCell>
                  <TableCell>: ₹{ContraToApprove?.cash_amount || "0.00"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><b>Transfer Type</b></TableCell>
                  <TableCell>: {ContraToApprove?.transfer_type || "Bank to bank"}</TableCell>
                  <TableCell><b>Created By</b></TableCell>
                  <TableCell>: {ContraToApprove?.created_by_name || "-"}</TableCell>
                </TableRow>
              </TableBody>
            </Table>

            <Table
              size="small"
              sx={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "14px",
                backgroundColor: "#fff",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <TableBody>
                {/* BANK TO BANK */}
                {ContraToApprove?.voucher_type === "BANK TO BANK" && (
                  <>
                    <TableRow sx={{ bgcolor: "#d9d8d8ff" }}>
                      <TableCell colSpan={4} align="center" sx={{ fontWeight: "bold" }}>
                        BANK TO BANK
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><b>From Bank</b></TableCell>
                      <TableCell>: {ContraToApprove?.from_account_name || "-"}</TableCell>
                      <TableCell><b>To Bank</b></TableCell>
                      <TableCell>: {ContraToApprove?.to_account_name || "-"}</TableCell>
                    </TableRow>
                  </>
                )}

                {/* CASH TO BANK */}
                {ContraToApprove?.voucher_type === "CASH TO BANK" && (
                  <>
                    <TableRow sx={{ bgcolor: "#d9d8d8ff" }}>
                      <TableCell colSpan={4} align="center" sx={{ fontWeight: "bold" }}>
                        CASH TO BANK
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><b>From Cash</b></TableCell>
                      <TableCell>: Cash Account</TableCell>
                      <TableCell><b>To Bank</b></TableCell>
                      <TableCell>: {ContraToApprove?.to_account_name || "-"}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><b>Cash Amount</b></TableCell>
                      <TableCell>: {ContraToApprove?.cash_amount || "-"}</TableCell>
                      <TableCell><b>Deposit Date</b></TableCell>
                      <TableCell>: {ContraToApprove?.date || "-"}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><b>Deposited By</b></TableCell>
                      <TableCell>: {ContraToApprove?.created_by_name || "-"}</TableCell>
                      <TableCell><b>Amount in Words</b></TableCell>
                      <TableCell>: {toWords.convert(ContraToApprove?.cash_amount || 0)}</TableCell>
                    </TableRow>
                  </>
                )}

                {/* BANK TO CASH */}
                {ContraToApprove?.voucher_type === "BANK TO CASH" && (
                  <>
                    <TableRow sx={{ bgcolor: "#d9d8d8ff" }}>
                      <TableCell colSpan={4} align="center" sx={{ fontWeight: "bold" }}>
                        BANK TO CASH
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><b>From Bank</b></TableCell>
                      <TableCell>: {ContraToApprove?.from_account_name || "-"}</TableCell>
                      <TableCell><b>To Account</b></TableCell>
                      <TableCell>: Cash Account</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><b>Cash Amount</b></TableCell>
                      <TableCell>: {ContraToApprove?.cash_amount || "-"}</TableCell>
                      <TableCell><b>Cheque/Ref No.</b></TableCell>
                      <TableCell>: {ContraToApprove?.cheque_no || "-"}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><b>Withdrawn By</b></TableCell>
                      <TableCell>: {ContraToApprove?.created_by_name || "-"}</TableCell>
                      <TableCell><b>Amount in Words</b></TableCell>
                      <TableCell>: {toWords.convert(ContraToApprove?.cash_amount || 0)}</TableCell>
                    </TableRow>
                  </>
                )}

                {/* COMMON ROWS */}
                <TableRow>
                  <TableCell><b>Narration</b></TableCell>
                  <TableCell colSpan={3}>: {ContraToApprove?.narration || "-"}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>

          <Divider sx={{ my: { xs: 1.5, md: 2 } }} />

          {/* ================= REMARK SECTION ================= */}
          {showRemarkForIndentId === ContraToApprove?.cv_id ? (
            <>
              <Typography
                variant="body2"
                sx={{
                  mb: 1,
                  fontSize: { xs: "0.8rem", md: "0.875rem" },
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Please enter remark before{" "}
                {actionType === "Approved" ? "approving" : "rejecting"}:
              </Typography>

              <TextField
                fullWidth
                size="small"
                value={remarkInput}
                onChange={(e) => setRemarkInput(e.target.value)}
                placeholder="Enter remark"
                multiline
                rows={2}
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-end" },
                  gap: 1,
                  mt: 2,
                }}
              >
                <Button
                  variant="contained"
                  color={actionType === "Approved" ? "success" : "error"}
                  size="small"
                  sx={{ minWidth: { xs: "100px", md: "80px" } }}
                  onClick={() => {
                    if (!remarkInput.trim()) {
                      toast.error("Remark is required!");
                      return;
                    }
                    handleApprove({
                      ...ContraToApprove,
                      status: actionType,
                      remarks: remarkInput,
                    });
                    setApproveAnchorEl(null);
                    setContraToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForIndentId(null);
                    setActionType(null);
                  }}
                >
                  Yes
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{ minWidth: { xs: "100px", md: "80px" } }}
                  onClick={() => {
                    setApproveAnchorEl(null);
                    setContraToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForIndentId(null);
                    setActionType(null);
                  }}
                >
                  No
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Typography
                variant="body2"
                sx={{
                  mb: 1,
                  fontSize: { xs: "0.8rem", md: "0.875rem" },
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Do you want to approve or reject this Contra Voucher?
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-end" },
                  gap: 1,
                  mt: 2,
                  flexWrap: "wrap",
                }}
              >
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  sx={{
                    minWidth: { xs: "80px", md: "70px" },
                    fontSize: { xs: "0.75rem", md: "0.875rem" },
                  }}
                  onClick={() => {
                    setShowRemarkForIndentId(ContraToApprove?.cv_id);
                    setActionType("Approved");
                  }}
                  disabled={ContraToApprove?.status === "Approved"}
                >
                  Approve
                </Button>

                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  sx={{
                    minWidth: { xs: "80px", md: "70px" },
                    fontSize: { xs: "0.75rem", md: "0.875rem" },
                  }}
                  onClick={() => {
                    setShowRemarkForIndentId(ContraToApprove?.cv_id);
                    setActionType("Rejected");
                  }}
                  disabled={ContraToApprove?.status === "Approved"}
                >
                  Reject
                </Button>

                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  sx={{
                    minWidth: { xs: "80px", md: "70px" },
                    fontSize: { xs: "0.75rem", md: "0.875rem" },
                  }}
                  onClick={() => handleEditClick(ContraToApprove)}
                  disabled={ContraToApprove?.status === "Approved"}
                >
                  Edit
                </Button>

                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  sx={{
                    minWidth: { xs: "80px", md: "70px" },
                    fontSize: { xs: "0.75rem", md: "0.875rem" },
                  }}
                  onClick={() => {
                    setApproveAnchorEl(null);
                    setContraToApprove(null);
                  }}
                >
                  Close
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Popover>
    </>
  );

}

export default ContraVoucher;
